import React from 'react';
import { Icon, IconButton, Tooltip } from '@mui/material';
import FilterCategoryMultiSelect from '../controls/FilterCategoryMultiSelect';
import { PortfolioService } from '../../services/portfolio.service';

interface FilterPortfoliosProps {
  statusFilter: string[];
  onChange: (values: string[]) => void;
  onClose: () => void;
}

const FilterPortfolios: React.FC<FilterPortfoliosProps> = ({
  statusFilter,
  onChange,
  onClose,
}) => {
  const hasActiveFilters = statusFilter.length > 0;

  return (
    <div className="filter-side-panel">
      <div className="filter-side-panel-header">
        <span>Uitgebreid zoeken</span>
        <div className="filter-side-panel-header-actions">
          {hasActiveFilters && (
            <Tooltip title="Verwijder alle filters">
              <IconButton size="small" onClick={() => onChange([])}>
                <Icon>delete</Icon>
              </IconButton>
            </Tooltip>
          )}
          <Tooltip title="Sluit filter">
            <IconButton size="small" onClick={onClose}>
              <Icon>close</Icon>
            </IconButton>
          </Tooltip>
        </div>
      </div>

      <div className="filter-side-panel-body">
        <div className="filter-section">
          {/* <h5>Overige filters</h5> */}
          <FilterCategoryMultiSelect
            label="Status"
            placeholder="Zoek en selecteer een of meerdere statussen"
            noOptionsText="Geen statussen beschikbaar"
            items={PortfolioService.STATUS_OPTIONS}
            selectedValues={statusFilter}
            onChange={onChange}
            chipStyleVariant="default"
          />
        </div>
      </div>
    </div>
  );
};

export default FilterPortfolios;
